export default __webpack_public_path__ + "static/media/code3.4608efd7.png";